import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { CostCalculator } from "@modules/study/costcalculator";

const ContactUs = () => {
  return (
    <LayoutMain
      title="Cost of Living Calculation"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/cost-of-living`}
    >
      <CostCalculator />
    </LayoutMain>
  );
};

export default ContactUs;
